import {useState} from "react";
import {Button, Tooltip, Typography} from "@matillion/component-library";
import {JsonDisplay} from "../../components/json-display/JsonDisplay.tsx";
import {useAtomValue} from "jotai";
import {ScanAtom} from "../3-perform-scan/ScanAtom.tsx";
import type {ScanResult} from "../3-perform-scan/scan-model/ScanResult.tsx";
import Styles from "./UploadWidget.module.scss";
import {uploadReplacer} from "./uploadReplacer.ts";
import {download} from "./download.ts";
import {DownloadSharedJobMigrationButton} from "./DownloadSharedJobMigrationButton.tsx";
import {UploadForm} from "./UploadForm.tsx";
import {ScanResultErrorWarning} from "../3-perform-scan/scan-result-display/ScanResultDisplay.tsx";

function DownloadDisplay({data}: {data: ScanResult}) {
    const [open, setOpen] = useState(false)
    return <div>
        <ScanResultErrorWarning result={data} />
        <div className={Styles.TitleBar}>
            <h2>Report Data </h2>
            {!open && <Tooltip content="Open report in browser. We recommend you download/upload your report before opening">
                <Button onClick={()=>setOpen(true)} alt="danger">View Report</Button>
            </Tooltip>}
            <Button onClick={()=>download(data, "scan.json", uploadReplacer)}>Download Report</Button>
            <DownloadSharedJobMigrationButton scan={data} />
        </div>
        {open && <JsonDisplay jsonObj={data} replacer={uploadReplacer} />}
        {!open && <Typography>
            Click "View Report" to open the report in the browser. We recommend you download/upload your report before
            opening as large reports can cause performance issues while viewing.
        </Typography>}
    </div>
}

export function UploadWidget() {
    const data = useAtomValue(ScanAtom);
    
    if (data == null) {
        return <div>No scan data available</div>;
    }

    return (
        <div>
            <DownloadDisplay data={data} />
            <UploadForm />
        </div>
    );
}